import { uniformGrid } from '../settingsHelpers';
import { DIMENSIONS, ITEMS, MS, TS, UNITS } from '../../constants';
const { width, depth, height } = DIMENSIONS;

export default {
  grid: uniformGrid(10),
  defaultFilter: 'sections',
  postWidth: 42,
  padHeight: 0,
  roomMinDesktop: {
    width: 4650,
    height: 2200,
  },
  roomMinSummary: {
    width: 1000,
    height: 1000,
  },
  roomMinMobile: {
    width: 2200,
    height: 2200,
  },
  distanceBetweenAttachments: 200,
  roomMax: {
    width: 8000,
    height: 5000,
  },
  zoomableScene: true,
  canvasMargins: { top: 30, right: 60 },
  canvasMarginsKiosk: { top: 30, right: 100 },
  canvasMarginsMobile: {
    top: 50,
    right: 40,
  },
  displaySectionMeasurements: false,
  measurements: {
    productsRemap: [
      {
        affects: [
          '30333286',
          '10547387',
          '60333850',
          '80547384',
          '00452619',
          '80452620',
          'S49275286',
        ],
        keys: {
          [DIMENSIONS.width]: DIMENSIONS.depth,
          [DIMENSIONS.height]: DIMENSIONS.height,
          Length: DIMENSIONS.width,
        },
      },
    ],
    displayMeasurement: [
      {
        affects: [ITEMS.SECTION, ITEMS.POST],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: false,
          format: `${height}${TS}${width} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.SHELF, ITEMS.PEGBOARD],
        rules: {
          display: true,
          measure: true,
          measurementPrefix: true,
          format: `${width} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.ADD_ON],
        rules: {
          display: false,
          measure: false,
          measurementPrefix: true,
          format: `${width} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.DIVIDER],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: true,
          format: `${width} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.CABINET, ITEMS.WORKBENCH, ITEMS.TROLLEY],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: true,
          format: `${width} ${MS}, ${depth} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
    ],
  },
  hideInfoIconForType: ['post'],
  bulkArticles: {
    80333284: {
      id: '30512283',
      bulkSize: 4,
    },
    30333842: {
      id: '00512289',
      bulkSize: 4,
    },
    90333288: {
      id: '10512279',
      bulkSize: 4,
    },
    40382785: {
      id: '90512280',
      bulkSize: 4,
    },
  },
  colorCodes: {
    white: '#F8F8F7',
    black: '#383E42',
    wood: '#F4D8A8',
    grey_green: '#738273',
  },
};
